import {
  Action,
  SetUserInfoPayload,
  UpdateFollowingTagsPayload,
  UpdateFollowingUsersPayload,
  UserInfoModel,
} from '../types';

type SetUserInfo = Action<SetUserInfoPayload, UserInfoModel>;

type UpdateFollowingUsers = Action<UpdateFollowingUsersPayload, UserInfoModel>;

type UpdateFollowingTags = Action<UpdateFollowingTagsPayload, UserInfoModel>;

export const setUserInfo: SetUserInfo =
  change =>
  ({ userInfo }) => ({
    userInfo: {
      ...change,
      followingUserIds:
        userInfo?.followingUserIds && userInfo?.followingUserIds.length > 0
          ? userInfo.followingUserIds
          : change.followingUserIds,
      followingTags:
        userInfo?.followingTags && userInfo?.followingTags.length > 0
          ? userInfo.followingTags
          : change.followingTags,
    },
  });

export const updateFollowingUsers: UpdateFollowingUsers =
  change =>
  ({ userInfo }) => ({
    userInfo: { ...userInfo, followingUserIds: change.followingUserIds },
  });

export const updateFollowingTags: UpdateFollowingTags =
  change =>
  ({ userInfo }) => ({
    userInfo: { ...userInfo, followingTags: change.followingTags },
  });
